import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const WarningModal = ({
  message,
  open,
  onClose,
  onOk,
  onCancel,
  type,
  selectedRows = [],
  isMessaging,
}) => {
  const [showDeleteData, setShowDeleteData] = useState(false);
  return (
    <Modal isOpen={open} toggle={onClose}>
      <ModalHeader
        className={
          type === "DELETE"
            ? "trivia_modal_header_bg_delete"
            : "trivia_modal_header_bg"
        }
        toggle={onClose}
      >
        Confirm
      </ModalHeader>
      <ModalBody>
        <div>
          {message} {isMessaging ? <span>({selectedRows.length})</span> : ""}
        </div>

        {isMessaging && type == "DELETE" ? (
          <div className="mt-3">
            <div className="link-text cursor-pointer" onClick={()=>{
              setShowDeleteData(!showDeleteData)
            }}>
              Click here to {showDeleteData?"hide":"show"} messages that will be deleted
            </div>


            {
              showDeleteData &&   <div className="delete_messages_list">
              <ul>
                {selectedRows.map((x) => {
                  return <li>{x.name}</li>;
                })}
              </ul>
            </div>
            }

          
          </div>
        ) : (
          ""
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={onOk}>
          {isMessaging ? "Yes delete these messages":"OK"} 
        </Button>
        <Button  color="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

WarningModal.propTypes = {
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default WarningModal;
